import './label.css';

/** Подпись поля. Стили — в `label.css` на токенах `--theme-*`. */
const Label = ({ className = '', ...props }) => (
  <label className={`label ${className}`.trim()} {...props} />
);

export { Label };
